// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1283":"9559bb146cd4c291","5348":"0dffb57325612553","6002":"454aeefd8af7b5a8"}[chunkId] + ".css";
};